const categoryRegistry = {};

function resolve(key) {
  if (!categoryRegistry[key]) {
    throw new Error(`Trying to get invalid category with key: ${key}`);
  }
  return categoryRegistry[key];
}

function register(key, componentsObject) {
  categoryRegistry[key] = componentsObject;
}

const registry = { resolve, register };

export default registry;
